// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1Dmp7","buttons":"RemoveExpirationActionButtons_buttons__2UCZJ"};